import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowPathDown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconArrowPathDown"><Path d="M4.36309 15.1384C3.68147 14.3249 4.25989 13.0856 5.32124 13.0856H8.00002V4.83565C8.00002 3.31687 9.23124 2.08565 10.75 2.08565H13.25C14.7688 2.08565 16 3.31687 16 4.83565V13.0856H18.6788C19.7402 13.0856 20.3186 14.3249 19.637 15.1384L13.7247 22.195C12.8254 23.2683 11.1746 23.2683 10.2754 22.195L4.36309 15.1384Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowPathDown;
